import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
  RadConnStyle as radStyle,
} from "../../../features/RadConnStyle";
import axios from "axios";
import { HttpJsonHeader } from "../../../features/Environments";
import { FormAutoB } from "../../../core/Helper";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import styled from "styled-components";

export default function UserRulePopup(props) {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const [configState, setConfigState] = props.configState; // setup menu for each rule ...
  const { selectedRow, formName, setUpdateFlag } = props;
  const [data, setData] = useState(null);
  const refForm1 = useRef(null);
  const dispatch = useDispatch();
  //----------------------------------------------------------------------
  useEffect(() => {
    if (selectedRow) {
      getData(() => {
        selectedRow.action("ready");
      });
    }
  }, [selectedRow]);

  //----------------------------------------------------------------------
  const getData = (goReady) => {
    if (selectedRow && selectedRow.row && selectedRow.row.ruleid === 0) {
      setData(null);
      goReady();
      return;
    }
    axios
      .post(
        process.env.REACT_APP_API + "api/userrule/get-data",
        selectedRow.row,
        HttpJsonHeader
      )
      .then((res) => {
        if (res.data.rows && res.data.rows.length > 0) {
          setData(res.data.rows[0]);
          goReady();
        }
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  //Saving Data TO server
  const saveData = (evt) => {
    const fData1 = Object.fromEntries(new FormData(refForm1.current));

    let dataToSave = {
      ItemId: selectedRow.row["ruleid"],
      SaveInfo: {
        ...fData1,
        ...tmpCheckState,
      },
      UserInfo: userDetail,
    };

    axios
      .post(
        process.env.REACT_APP_API + "api/userrule/update",
        dataToSave,
        HttpJsonHeader
      )
      .then((res) => {
        dispatch(
          setReminder({ show: true, message: "บันทึกสมบูรณ์", type: "success" })
        );
        setWinState({ show: false });
        setUpdateFlag(true);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  // FIELDS Ojbect list
  const tmpCheckState = {
    flag_add: data ? data.flag_add : "n",
    flag_edit: data ? data.flag_edit : "n",
    flag_delete: data ? data.flag_delete : "n",
    flag_print: data ? data.flag_print : "n",

    flag_diagnosis: data ? data.flag_diagnosis : "n",
    flag_result_edit: data ? data.flag_result_edit : "n",
    flag_result_view: data ? data.flag_result_view : "n",
    flag_result_del: data ? data.flag_result_del : "n",

    flag_user_insertion: data ? data.flag_user_insertion : "n",
    flag_admin: data?.flag_admin ?? "n",
    flag_super: data?.flag_super ?? "n",
  };
  const FILEDS = [
    { label: "รหัส", oName: "rulecode", require: true, type: "text" },
    {
      label: "ชื่อสิทธิใช้งาน",
      oName: "rulename",
      require: true,
      type: "text",
    },
    { label: "ชื่อแบบสั้น", oName: "ruleshort", require: true, type: "text" },
  ];

  const FILEDS2 = [
    {
      label: "เพิ่มข้อมูล",
      oName: "flag_add",
      require: true,
      type: "checkbox",
    },
    {
      label: "แก้ไขข้อมูล",
      oName: "flag_edit",
      require: true,
      type: "checkbox",
    },
    {
      label: "ลบข้อมูล",
      oName: "flag_delete",
      require: true,
      type: "checkbox",
    },
    {
      label: "พิมพ์รายงาน",
      oName: "flag_print",
      require: true,
      type: "checkbox",
    },
  ];

  const FIELDS3 = [
    {
      label: "อ่านผล",
      oName: "flag_diagnosis",
      require: true,
      type: "checkbox",
    },
    {
      label: "แก้ไขผลอ่าน",
      oName: "flag_result_edit",
      require: true,
      type: "checkbox",
    },
    {
      label: "ดูผลอ่าน",
      oName: "flag_result_view",
      require: true,
      type: "checkbox",
    },
    {
      label: "ลบผลอ่าน",
      oName: "flag_result_del",
      require: true,
      type: "checkbox",
    },
  ];

  const FIELDS4 = [
    {
      label: "เพิ่มแก้ไขผู้ใช้ระบบ",
      oName: "flag_user_insertion",
      require: true,
      type: "checkbox",
    },
    {
      label: "Admin",
      oName: "flag_admin",
      require: true,
      type: "checkbox",
    },
    {
      label: "Supervisor",
      oName: "flag_super",
      require: true,
      type: "checkbox",
    },
  ];

  //----------------------------------------------------------------------
  // Return Zone
  return (
    <MyModal
      show={winState.show}
      size="lg"
      centered
      backdrop={false}
      onHide={() => {
        setWinState({ show: false });
      }}
    >
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <HBox>
        <ModalBodyBlack>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form1",
                items: FILEDS,
                data: data,
                refTo: refForm1,
              }}
            />
          ) : null}
        </ModalBodyBlack>
      </HBox>
      <HBox>
        <VBox>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form2",
                items: FILEDS2,
                data: data,
                tmpCheckState: tmpCheckState,
                refTo: null,
              }}
            />
          ) : null}
        </VBox>
        <VBox>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form3",
                items: FIELDS3,
                data: data,
                tmpCheckState: tmpCheckState,
                refTo: null,
              }}
            />
          ) : null}
        </VBox>
        <VBox>
          {FILEDS ? (
            <FormAutoB
              {...{
                formId: "form4",
                items: FIELDS4,
                data: data,
                tmpCheckState: tmpCheckState,
                refTo: null,
              }}
            />
          ) : null}
        </VBox>
      </HBox>

      <ModalFooterBlack>
        <HBox style={{ justifyContent: "left" }}>
          <Button
            variant="info"
            onClick={() => setConfigState({ show: true, action: (e) => {} })}
          >
            แก้ไขเมนู
          </Button>
        </HBox>

        <HBox style={{ justifyContent: "right" }}>
          <Button
            style={{ marginRight: "5px" }}
            variant="primary"
            onClick={() => saveData()}
          >
            Save changes
          </Button>
          <Button variant="danger" onClick={() => setWinState({ show: false })}>
            Close
          </Button>
        </HBox>
      </ModalFooterBlack>
    </MyModal>
  );
}

const HBox = styled.div`
  flex: 1;
  display: flex;
`;

const VBox = styled.div`
  flex: 1;
  padding: 10px 20px 20px 30px;
  background-color: #1f1d1d;
`;
